import _ from "lodash";
import {
  handleChangeActionType,
  handleChangeAllActionType,
  handleChangeToInitStateActionType,
} from "../../actions/handleChangeAction";

export const INITIAL_STATE = {
  ileggelsesnummer: "",
  fraDato: "",
  tilDato: "",
  tjenestenummer: "",
  mottaker: "",
  gatenavn: "",
  gatenummer: "",
  bydel: "",
  leveringstype: "",
  overtredelseskode: "",
  saksnummer: "",
  vedtakskode: "",
  klagekode: "",
  fraIneOverforingsdato: "",
  tilIneOverforingsdato: "",
  // Statuser
  isVenter: 0,
  isTilEttersendelse: null,
  isEttersendt: null,
  isMakulert: false,
  isKlarTilKemner: null, // Skal stå som isKlarTilKemner tils endret på backend
  isStoppetAvSystemet: null,
  isFeiletKemner: null,
  isSendtKemner: null, // Skal stå isSendtKemner tils backend er endret til isSendtIne
  isBetalt: null,
  isMaKvalitetsikres: null,
  // Parameters which are none existing in backend
  selectedStatuser: [],
  tilTid: "",
  fraTid: "",
  teamId: null,
  fraDatoValidationErrorText: null,
  fraTidValidationErrorText: null,
  tilDatoValidationErrorText: null,
  tilTidValidationErrorText: null,
  fraIneOverforingsdatoValidationErrorText: null,
  tilIneOverforingsdatoValidationErrorText: null,
  validationError: {
    ileggelsesnummer: null,
    tjenestenummer: null,
    saksnummer: null,
  },
};

export default function miljogebyrerOversiktFilterFormReducer(
  state = {
    ...INITIAL_STATE,
    validationError: { ...INITIAL_STATE.validationError },
  },
  action,
) {
  switch (action.type) {
    case handleChangeActionType("MILJOGEBYRER_OVERSIKT_FILTER_FORM"):
      _.set(state, action.variableName, action.payload);
      return { ...state };
    case handleChangeAllActionType("MILJOGEBYRER_OVERSIKT_FILTER_FORM"):
      return { ...action.payload };
    case handleChangeToInitStateActionType("MILJOGEBYRER_OVERSIKT_FILTER_FORM"):
      return {
        ...INITIAL_STATE,
        validationError: { ...INITIAL_STATE.validationError },
      };
    default:
      return state;
  }
}
